<div class="spinner-container" *ngIf="!checkLoadedResend()">
    <mat-spinner class="content-box"></mat-spinner>
</div>

<mat-card appearance="outlined" class="mat-elevation-z8" *ngIf="checkLoadedResend()">

    <!-- Business Signing -->
    <div class="txt warning-message" *ngIf="!validCertificates">
        <strong>{{'historyTexts.noValidCerts' | translate}}</strong>
    </div>

    <mat-card-content class="container">
        <mat-horizontal-stepper *ngIf="validCertificates" linear #stepper="matHorizontalStepper" class="row">
            <ng-template matStepperIcon="done">
                <cqes-icon icon="check"></cqes-icon>
            </ng-template>
            <ng-template matStepperIcon="edit">
                <cqes-icon icon="check"></cqes-icon>
            </ng-template>
            <mat-step [completed]="signingStepCompleted" class="col-3" [editable]="isEditable">

                <div class="row">
                    <div>
                        <mat-form-field class="package-name col-md-7">
                            <mat-label>{{ 'businessTexts.packageName' | translate }}</mat-label>
                            <input matInput [formControl]="packageNameControl" />
                            <mat-error *ngIf="packageNameControlErrMsg$ | async as error ">
                                {{ error | translate }}
                            </mat-error>
                        </mat-form-field>
                        <br>
                        <mat-form-field class="description">
                            <mat-label>{{ 'businessTexts.description' | translate }}</mat-label>
                            <input matInput [formControl]="packageDescriptionControl" />
                            <mat-error *ngIf="packageDescriptionControlErrMsg$ | async as error ">
                                {{ error | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>


                <div class="row">
                    <div class="col-md-7 section">
                        <div class="txt">
                            {{ 'businessTexts.documents' | translate }}
                        </div>
                        <ng-template matStepLabel>{{'businessTexts.sendDocuments' | translate }}</ng-template>
                        <div class="dropzone txt padding">
                            <input type="file" #fileDropRef id="fileDropRef" multiple [disabled]="isResend"
                                (change)="fileBrowseHandler($event.target.files)">
                            <label for="fileDropRef" [ngClass]="{'disabled': isResend }">
                                <cqes-icon icon="file_upload"
                                    [ngClass]="{ 'upload': !isResend, 'inactive-icon': isResend }"></cqes-icon>
                                {{ 'businessTexts.chooseFile' | translate }}

                            </label>
                            {{ 'businessTexts.orDragAndDrop' | translate }}
                            <div class="files-list">
                                <div *ngFor="let f of files; let i = index" class="file-holder">
                                    <span *ngIf="!isResend" class="name"><strong>{{f.file.name}} </strong></span>
                                    <span *ngIf="isResend" class="name"><strong>{{f.fileName}} </strong></span>
                                    <div class="file-actions">
                                        <strong>
                                            {{f.file.size | filesize}}
                                        </strong>
                                        <span class="noSign-check">
                                            <mat-checkbox [ngModel]="!f.signable" (ngModelChange)="f.signable = !$event"
                                                color="primary" [disabled]="isResend">
                                                {{'businessTexts.noSign' | translate }} </mat-checkbox>
                                            <mat-checkbox [ngModel]="f.previewRequired" (ngModelChange)="f.previewRequired = $event"
                                                color="primary" [disabled]="isResend">
                                                {{'businessTexts.previewRequired' | translate }} </mat-checkbox>
                                        </span>
                                        <cqes-icon class="file-icon" icon="description"
                                            matTooltip="{{'businessTexts.previewDocument' | translate}}"
                                            (click)="$event.preventDefault();$event.stopPropagation();viewFile(f.file)"></cqes-icon>
                                        <cqes-icon class="file-icon" icon="settings"
                                            [ngClass]="{'inactive-action-icon': isResend }"
                                            matTooltip="{{'businessTexts.additionalSignSettings' | translate}}"
                                            (click)="$event.preventDefault();$event.stopPropagation();openSettings(f);"></cqes-icon>
                                        <cqes-icon class="file-icon" icon="cancel"
                                            [ngClass]="{'inactive-action-icon': isResend }"
                                            matTooltip="{{'businessTexts.removeDocument' | translate}}"
                                            (click)="deleteFile(i)"></cqes-icon>
                                        <cqes-icon class="file-icon" icon="touch_app" *ngIf="isPdf(f)"
                                            [class.inactive-action-icon]="!isSignable(f)"
                                            matTooltip="{{'signingTexts.info.selectSignPosition' | translate}}"
                                            (click)="openPositionDialog(f, i)"></cqes-icon>
                                    </div>
                                </div>
                            </div>
                            <ng-template matStepLabel matStepperIcon="done">
                                <cqes-icon icon="check"></cqes-icon>
                            </ng-template>
                        </div>
                        <mat-error *ngIf="showValidations && !files.length" class="error">{{
                            'businessTexts.fileRequired' | translate }}</mat-error>
                        <mat-error *ngIf="showValidations && !hasSignableFile()" class="error">{{
                            'businessTexts.signableFileRequired' | translate }}</mat-error>
                    </div>

                    <div class="col-md-5">
                        <div class="txt">
                            {{ 'businessTexts.packageSettings' | translate }}
                        </div>
                        <div class="package-settings txt">
                            <mat-checkbox color="primary" [(ngModel)]="packageToArchive" [disabled]="isResend">
                                {{ 'businessTexts.packageToArchive' | translate }}
                            </mat-checkbox> <br>
                            <mat-checkbox color="primary" [(ngModel)]="packageAvailable" [disabled]="isResend">
                                {{ 'businessTexts.packageAvailable' | translate }} </mat-checkbox> <br>
                            <mat-checkbox color="primary" [(ngModel)]="recepientPays" [disabled]="isResend">
                                {{ 'businessTexts.packageReceiversPay' | translate }}</mat-checkbox> <br>
                            <div class="validity-section">
                                <span>{{ 'businessTexts.signerPeriod' | translate }}: </span>
                                <mat-select class="validity" placeholder="{{'signingTexts.validity' | translate}}"
                                    name="validity-period" [ngModel]="validity">
                                    <mat-option *ngFor="let p of periodsDictionary" (click)="onSelectPeriod(p.value)"
                                        [value]="p.value">
                                        {{p.key}} {{getUnitTranslation(p.key, p.unit)}}
                                    </mat-option>
                                </mat-select>

                            </div>
                            <br>
                            <!-- future implementation -->
                            <!-- <div class="reminder-section">
                                <span>{{ 'businessTexts.singleSignerReminder' | translate }}: </span>
                                <mat-select class="validity" placeholder="{{'signingTexts.Reminder' | translate}}"
                                    name="reminder-period" [ngModel]="reminder">
                                    <mat-option *ngFor="let p of periodsDictionary" (click)="onSelectReminderPeriod(p.value)"
                                        [value]="p.value">
                                        {{p.key}} {{getUnitTranslation(p.key, p.unit)}}
                                    </mat-option>
                                </mat-select>
                            </div> -->

                            <button mat-raised-button class="margin-left" color="accent" (click)="openPositionPanel()"
                                [disabled]="isMainPosButtonDisabled()">
                                <cqes-icon class="position-icon" icon="touch_app"></cqes-icon>
                                {{'signingTexts.info.selectSignPosition' | translate}}
                            </button>
                            <br>
                            <mat-checkbox color="primary" [(ngModel)]="visibleSignature"
                                [disabled]="isResend || !hasPdf()">
                                {{ 'signingTexts.visibleSignature' | translate }}
                            </mat-checkbox>
                        </div>
                    </div>

                </div>

                <div class="row">
                    <div class="col-md-7">
                        <div class="txt">
                            {{ 'businessTexts.receivers' | translate }}
                        </div>
                        <div class="receivers txt">
                            <div class="txt search-container padding">
                                <mat-form-field class="search-input">
                                    <input matInput placeholder="{{'signingTexts.info.addReceiver' | translate}}"
                                        [(ngModel)]="userIdentifier" (keydown.enter)="searchUser()"
                                        [disabled]="isResend">
                                </mat-form-field>

                                <button class="search-button" mat-raised-button color="accent" (click)="searchUser()"
                                    [disabled]="isResend">
                                    {{'signingTexts.info.add' | translate}}
                                </button>
                                <button class="search-button" mat-raised-button color="accent" (click)="addSelf()"
                                    [disabled]="isResend">
                                    {{'signingTexts.info.addSelf' | translate}}
                                </button>

                                <!-- Drag and drop receivers in list -->
                                <div *ngIf="users.length > 0 && !loadingList" cdkDropList class="receivers-list"
                                    (cdkDropListDropped)="drop($event)">
                                    <div class="receiver-box" [ngClass]="{'signed': checkSigned(i) }"
                                        *ngFor="let user of users; let i=index" cdkDrag [cdkDragDisabled]="isResend">
                                        <strong>
                                            {{i+1}}. {{displayUserName(user.cmrId)}}
                                        </strong>
                                        <cqes-icon class="chip-icon" icon="cancel" *ngIf="!isResend"
                                            (click)="removeSigner(user.cmrId)"></cqes-icon>
                                        <cqes-icon matTooltip="{{'businessTexts.signed' | translate}}" class="chip-icon"
                                            icon="edit" *ngIf="isResend && checkSigned(i)"></cqes-icon>
                                        <cqes-icon matTooltip="{{'businessTexts.waitingToSign' | translate}}"
                                            class="chip-icon" icon="info"
                                            *ngIf="isResend && !checkSigned(i)"></cqes-icon>
                                    </div>
                                </div>

                                <div class="loading-spinner-receivers" *ngIf="loadingList || savingList">
                                    <mat-spinner class="content-box-receivers"></mat-spinner>
                                </div>

                                <mat-error *ngIf="showValidations && !users.length" class="error">{{
                                    'businessTexts.receiverRequired' | translate }}</mat-error>

                                <div class="identifier-format-instructions">
                                    <i *ngIf="(users.length == 0 && usersInCopy.length == 0) &&  !isResend">
                                        {{'signingTexts.userIdentifierFormatPackage' | translate}}
                                    </i>
                                </div>

                                <div class="select-receivers">
                                    <mat-select placeholder="{{'businessTexts.selectReceivers' | translate}}"
                                        [(ngModel)]="selectedListId" [ngClass]="{'inactive-select': isResend }"
                                        name="receivers-list"
                                        [disabled]="isResend || (!receiversList.length && loadedLists)">
                                        <mat-option *ngFor="let list of receiversList" [value]="list.id">
                                            {{list.name}}
                                        </mat-option>
                                    </mat-select>
                                    <button mat-raised-button color="accent" (click)="onSelectReceiversList()"
                                        type="button" matTooltip="{{'businessTexts.selectReceivers' | translate}}"
                                        matTooltipPosition="above" class="icon-btn"
                                        [disabled]="isResend || (!receiversList.length && loadedLists)">
                                        <cqes-icon icon="people_outline" class="list-icon"></cqes-icon>
                                    </button>
                                    <button mat-raised-button color="warn" (click)="deleteReceiversList()"
                                        type="button" matTooltip="{{'businessTexts.deleteReceiversList' | translate}}"
                                        matTooltipPosition="above" class="icon-btn delete-btn"
                                        [disabled]="isResend || !selectedListId">
                                        <cqes-icon icon="delete" class="list-icon"></cqes-icon>
                                    </button>
                                    <div class="identifier-format-instructions">
                                        <i *ngIf="!receiversList.length && loadedLists">
                                            {{'businessTexts.noSavedLists' | translate}}
                                        </i>
                                    </div>
                                </div>
                                <mat-form-field class="receivers-list-input" *ngIf="users.length">
                                    <input matInput placeholder="{{'businessTexts.saveReceiversList' | translate}}"
                                        (keydown.enter)="addReceiversList()" [(ngModel)]="receiversListName"
                                        [disabled]="isResend">
                                </mat-form-field>
                                <button mat-raised-button color="accent" (click)="addReceiversList()" type="button"
                                    matTooltip="{{'businessTexts.saveReceiversList' | translate}}"
                                    matTooltipPosition="below" class="icon-btn" [disabled]="isResend"
                                    *ngIf="users.length">
                                    <div class="plus">
                                        +
                                    </div>
                                    <cqes-icon icon="group" class="group-icon"></cqes-icon>
                                </button>
                            </div>
                        </div>

                        <div class="txt margin">
                            {{ 'businessTexts.accessLabel' | translate }}
                        </div>
                        <div class="access txt padding">
                            <div class="cc-container">
                                <!-- users in CC -->
                                <mat-expansion-panel [expanded]="isResend" [disabled]="isResend"
                                    *ngIf="checkResendCopied()">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>{{ 'signingTexts.info.addReceiverInCopy' | translate
                                            }}</mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <div>
                                        <mat-form-field class="search-input">
                                            <input matInput
                                                placeholder="{{'signingTexts.info.addReceiverInCopy' | translate}}"
                                                [(ngModel)]="userIdentifierCc" (keydown.enter)="searchUser('copy')"
                                                [disabled]="isResend">
                                        </mat-form-field>


                                        <button class="search-button" mat-raised-button color="accent"
                                            (click)="searchUser('copy')" [disabled]="isResend">
                                            {{'signingTexts.info.add' | translate}}
                                        </button>


                                        <!-- receivers in cc -->
                                        <div *ngIf="usersInCopy.length > 0" class="receivers-list">
                                            <div class="receiver-box" *ngFor="let user of usersInCopy; let i=index">
                                                <div [ngClass]="{'name-box': isResend }">
                                                    <strong>
                                                        {{displayUserCcName(user)}}
                                                    </strong>
                                                    <cqes-icon class="chip-icon" icon="cancel"
                                                        (click)="removeSignerCc(user.cmrId)"
                                                        *ngIf="!isResend"></cqes-icon>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </mat-expansion-panel>
                                <div class="instructions">
                                    <i *ngIf="usersInCopy.length == 0 &&  !isResend">
                                        {{'businessTexts.copyInstructions' | translate}}
                                    </i>
                                </div>
                            </div>

                            <div *ngIf="groups.length">

                                <div [formGroup]="groupIdsForm">
                                    <div class="form-checkbox-container">
                                        <mat-form-field class="groups" matTooltip="{{getGroupsTooltip()}}">
                                            <mat-label *ngIf="hasGroups()">{{'businessTexts.accessGroup' |
                                                translate}}</mat-label>
                                            <mat-label *ngIf="!hasGroups()">{{'businessTexts.selectAccessGroup' |
                                                translate}}</mat-label>
                                            <mat-select placeholder="{{'businessTexts.selectAccessGroup' | translate}}"
                                                formControlName="groupIds" [ngClass]="{'inactive-select': isResend }"
                                                multiple [compareWith]="compareObjects" name="group-signers"
                                                [disabled]="sendWithoutGroups">
                                                <mat-select-trigger>
                                                    {{getTriggerMessage()}}
                                                </mat-select-trigger>
                                                <mat-option *ngFor="let group of groups" [value]="group.id">
                                                    {{sendWithoutGroups ? ('businessTexts.sendWithoutGroups' |
                                                    translate) : group.name}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-checkbox class="groups" (change)="sendWithoutGroupsChecked($event)"
                                            color="primary">
                                            {{'businessTexts.sendWithoutGroupsShort' | translate }}
                                        </mat-checkbox>

                                    </div>
                                </div>
                                <div class="instructions">
                                    <i *ngIf="checkInstructions()">
                                        {{'businessTexts.groupInstructions' | translate}}
                                    </i>
                                </div>
                            </div>


                            <!-- future implementation -->
                            <!--
                                <br>
                                <div class="reminder-section">
                                <span>{{ 'businessTexts.singleSignerReminder' | translate }}: </span>
                                <mat-select class="validity" placeholder="{{'signingTexts.Reminder' | translate}}"
                                    name="reminder-period" [ngModel]="reminder">
                                    <mat-option *ngFor="let p of periodsDictionary" (click)="onSelectReminderPeriod(p.value)"
                                        [value]="p.value">
                                        {{p.key}} {{getUnitTranslation(p.key, p.unit)}}
                                    </mat-option>
                                </mat-select>
                            </div> -->
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 section">
                        <button mat-raised-button color="accent" (click)="onSend()" type="button"
                            class="act-btn">{{texts.info.send }}
                        </button>
                        <button mat-raised-button color="accent" (click)="onCancel()" type="button"
                            class="act-btn">{{'settingsList.common.cancel' | translate}}
                        </button>
                    </div>
                </div>


            </mat-step>
            <mat-step class="col-3">
                <ng-template matStepLabel>{{texts.signResult}}</ng-template>
                <div class="result">
                    <div *ngIf="loading">
                        <span>
                            {{ 'businessTexts.packageSent' | translate }}
                        </span>
                        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                    </div>
                    <div *ngIf="!loading">
                        <strong>
                            <span *ngIf="isSentSuccessfully">{{ 'businessTexts.packageSentSuccess' | translate }}</span>
                            <span *ngIf="!isSentSuccessfully" class="error">{{'signingTexts.signingError' |
                                translate}}</span>
                        </strong>
                    </div>
                </div>

                <mat-card-actions class="tar">
                    <button [disabled]="loading" mat-raised-button matStepperPrevious
                        (click)="onCancel()">{{'common.back'
                        | translate}}</button>
                </mat-card-actions>
            </mat-step>
        </mat-horizontal-stepper>
    </mat-card-content>
</mat-card>
